import { useEffect, useState } from 'react';
import useEmbeddedKendoReportData from '../../state/embeddedKendoReport/UseEmbeddedKendoReportData';

const INITIAL_VIEW_STATE = { reportData: [], isLoaded: false };

const useViewDynamicKendoReport = (reportId, reportParameters) => {
  const [viewState, setViewState] = useState({ ...INITIAL_VIEW_STATE });
  const { getKendoReportData, getKendoReportTitle } = useEmbeddedKendoReportData();

  useEffect(() => {
    if (reportId) {

      setViewState({
        ...viewState,
        isLoaded: false,
        reportData: [],
        reportTitle:''
      });

      const reportPromise = getKendoReportData(reportId, reportParameters);

      if (reportPromise) {
        reportPromise
          .then((ret) => {
            setViewState({
              ...viewState,
              isLoaded: true,
              reportData: (ret.objData || []),
            })
          })
          .catch((error) => {
            console.error('Error executing BigQuery script:', error);
            setViewState({
              ...viewState,
              isLoaded: true,
              reportData: [],
            });
          });
      }

      const reportTitle = getKendoReportTitle(reportId, reportParameters);

      if (reportTitle) {
        reportTitle
          .then((ret) => {
            setViewState({
              ...viewState,
              isLoaded: true,
              reportTitle: (ret.objData[0].title || ''),
            })
          })
          .catch((error) => {
            console.error('Error executing BigQuery script:', error);
            setViewState({
              ...viewState,
              isLoaded: true,
              reportTitle: [],
            });
          });
      }

    }
  }, [reportParameters, reportId]);

  return { ...viewState };
};

export default useViewDynamicKendoReport;